module.exports = __webpack_public_path__ + "static/media/insightsCoverMobile.801dbb10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/insightsCoverMobile.jpg
// module id = 818
// module chunks = 3